export default __webpack_public_path__ + "static/blog-post-d7b5428ac1ac5b48f9cc8457d74221f9.jpg";